module.exports = __webpack_public_path__ + "img/shiba-loading.1ed2083b.png";